import { client } from "@nimble/core-client/client";
import * as coreApiClient from "@nimble/core-client/sdk";
import { raisableFetch } from "@nimble/react-requests/api-clients/fetch-config";

import { buildCsrfHeaders } from "@/lib/helpers/request-headers";

client.setConfig({
  baseUrl: "/",
  credentials: "include",
  fetch: raisableFetch,
});

// Dynamically fetch CSRF token from cookies on each request
// Without this interceptor, stale CSRF tokens from cached requests cause 403 errors after login/logout
client.interceptors.request.use((request) => {
  const csrfHeaders = buildCsrfHeaders();

  Object.entries(csrfHeaders).forEach(([key, value]) => {
    request.headers.set(key, value);
  });

  return request;
});

export default coreApiClient;
